import { select, put, all } from 'redux-saga/effects';
import { fetch } from '../../../_app/middleware/fetch';
import config from '../../../config';

// ACTIONS

export const SET_STAFF_PASSWORD = 'SET_STAFF_PASSWORD';
export const SET_QUERY_STRING_PARAMS = 'SET_QUERY_STRING_PARAMS';
export const CHECK_PASSWORD_PREVIOUSLY_SET = 'CHECK_PASSWORD_PREVIOUSLY_SET';
export const PASSWORD_PREVIOUSLY_SET_TOGGLE = 'PASSWORD_PREVIOUSLY_SET_TOGGLE';
export const SET_NEW_PASSWORD = 'SET_NEW_PASSWORD';
export const TOGGLE_PASSWORD_CHECK_PERFORMED =
  'TOGGLE_PASSWORD_CHECK_PERFORMED';

// ACTION CREATORS

export function setStaffPassword(password) {
  return { type: SET_STAFF_PASSWORD, payload: password };
}

export function setQueryStringParams(params) {
  return { type: SET_QUERY_STRING_PARAMS, payload: params };
}

export function checkPasswordPreviouslySet() {
  return { type: CHECK_PASSWORD_PREVIOUSLY_SET };
}

// export function passwordPreviouslySetToggle(boolean) {
//   return { type: PASSWORD_PREVIOUSLY_SET_TOGGLE, payload: boolean };
// }

export function setNewPassword() {
  return { type: SET_NEW_PASSWORD };
}

export function togglePasswordCheckPerformed(boolean) {
  return { type: TOGGLE_PASSWORD_CHECK_PERFORMED, payload: boolean };
}

// SAGAS

const getQueryStringParams = state =>
  state.setupStaffPassword.queryStringParams;
const getStaffPassword = state => state.setupStaffPassword.password;
const getRegistrationId = () => 'f108ec7f-49aa-4d41-8033-efb90d09b802';
// const getRegistrationId = state => state.onboarding.registrationId;

export function* getPasswordPreviouslySet() {
  const params = yield select(getQueryStringParams);
  const registrationId = yield select(getRegistrationId);
  const inviteToken = params.token;

  const action = {
    data: null,
    method: 'get',
    url: `${
      config.REACT_APP_API_BASE_URL
    }/districts/onboarding/${registrationId}/${inviteToken}/check-staff-password`,
  };

  const response = yield fetch(action);
  yield all([
    put({
      type: TOGGLE_PASSWORD_CHECK_PERFORMED,
      payload: true,
    }),
    put({
      type: PASSWORD_PREVIOUSLY_SET_TOGGLE,
      payload: response.data.isPasswordSet,
    }),
  ]);
}

export function* postNewPassword() {
  const params = yield select(getQueryStringParams);
  const registrationId = yield select(getRegistrationId);
  const newPassword = yield select(getStaffPassword);
  const inviteToken = params.token;

  const postData = {
    password: newPassword,
  };

  const action = {
    data: postData,
    method: 'post',
    url: `${
      config.REACT_APP_API_BASE_URL
    }/districts/onboarding/${registrationId}/${inviteToken}/set-staff-password`,
  };

  const response = yield fetch(action);
  if (response.status === 200 && params.redirectUrl) {
    window.location = params.redirectUrl;
  }
}

// SETUP STAFF PASSWORD REDUCER

const initialState = {
  password: '',
  passwordCheckPerformed: false,
  passwordPreviouslySet: false,
  queryStringParams: {},
};

export const staffPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_STAFF_PASSWORD:
      return {
        ...state,
        password: action.payload,
      };

    case SET_QUERY_STRING_PARAMS:
      return {
        ...state,
        queryStringParams: action.payload,
      };

    case PASSWORD_PREVIOUSLY_SET_TOGGLE:
      return {
        ...state,
        passwordPreviouslySet: action.payload,
      };

    case TOGGLE_PASSWORD_CHECK_PERFORMED:
      return {
        ...state,
        passwordCheckPerformed: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/staff-password/setup-staff-password.duck.js